import { InputText, Select, SelectProps, Wizard } from '@driftt/dds'
import { InputProps } from '@driftt/dds/dist/packages/core/src/lib/components/InputBase'
import React, { useMemo } from 'react'

import useWorkspacesGeoTargeting from 'hooks/useWorkspacesGeoTargeting'

import { useFLWizardStore } from '../FLCreationWizard.context'
import { StyledStepContainer } from '../FLCreationWizard.styles'
import { FLCreationWizardStepSidePanel } from '../FLCreationWizardStepSidePanel'

export const FLCreationWizardStepName = () => {
  const { orgHasWorkspaces, allWorkspaces } = useWorkspacesGeoTargeting()

  const {
    store: { playbookName, workspaceId },
    setStore: setWizardStore,
  } = useFLWizardStore()

  const options = useMemo(
    () =>
      Object.keys(allWorkspaces).map((workspaceId) => ({
        label: allWorkspaces[workspaceId as keyof typeof allWorkspaces].name,
        value: workspaceId,
      })),
    [allWorkspaces]
  )

  const handleWorkspaceChange = (newVal: typeof options[number]) => {
    if (newVal) {
      setWizardStore((curr) => ({
        ...curr,
        workspaceId: newVal.value,
      }))
    }
  }

  const handlePlaybookNameChange: InputProps['onChange'] = (e) => {
    setWizardStore((curr) => ({
      ...curr,
      playbookName: e.target.value,
    }))
  }

  return (
    <Wizard.Step split="center">
      <StyledStepContainer>
        {orgHasWorkspaces && allWorkspaces && (
          <Select
            label="Select Workspace"
            placeholder="Select one..."
            size="fullWidth"
            value={{
              label:
                allWorkspaces[workspaceId as keyof typeof allWorkspaces]
                  ?.name ?? '',
              value: workspaceId,
            }}
            options={options}
            onChange={handleWorkspaceChange as SelectProps['onChange']}
          />
        )}
        <InputText
          size="full-width"
          label="Playbook name"
          placeholder="Name your playbook"
          description="We recommend including the form type: Fastlane - Demo form"
          value={playbookName}
          onChange={handlePlaybookNameChange}
        />
        <Wizard.StepActionButton />
      </StyledStepContainer>
      <FLCreationWizardStepSidePanel variant="formSubmission" />
    </Wizard.Step>
  )
}
